module.exports = __webpack_public_path__ + "img/man.0e21ae37.svg";